module.exports = __webpack_public_path__ + "static/media/medal.e125c47a.svg";